<template>
  <v-container>
    <v-layout align-center justify-start>
      <div>
        テキストをコピーしてお使いください。
      </div>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <textarea v-model="message" ref="copytext" @click="$refs.copytext.select()" readonly></textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    // シェアするURL
    shareUrl: {
      type: String,
      default: ''
    },
    // シェアするメッセージ
    shareMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      message: ''
    }
  },
  methods: {
    formatTweetTags() {
      let tweetTagStr = "";
      const tags = this.$store.state.tags;
      for (let tag of tags) {
        tweetTagStr += ' #' + tag;
      }
      return tweetTagStr;
    }
  },
  mounted() {
    const tweetTagStr = this.formatTweetTags();
    this.message = this.shareMessage + ' ' + this.shareUrl + tweetTagStr;
    console.log(this.message);
  }
};
</script>

<style scoped lang="scss">
div {
  text-align: center;
  textarea {
    width: 100%;
    border: 1px solid #999999;
    padding: 5px;
  }
}
</style>